import { useTheme } from "@mui/material"
import { useContextState } from "../../../../../../../../../../hooks/theme"


const useStyles = () => {
    const { colors } = useContextState()
    const { breakpoints } = useTheme()
    return {
        container: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            '& .MuiGrid-root': {
                justifyContent: 'start'
            }
        },
        optionsAdd: (disable: boolean) => ({
            marginTop: '12px',
            width: '30px',
            '& .MuiIconButton-root': {
                color: disable ? colors.color32 : colors.color4,
                padding: 0,
                '& .MuiSvgIcon-root': {
                    fontSize: '30px',
                },
            },
        }),
        optionsAddText: (disable: boolean) => ({
            width: '30px',
            '& .MuiIconButton-root': {
                color: disable ? colors.color32 : colors.color4,
                padding: 0,
                '& .MuiSvgIcon-root': {
                    fontSize: '30px',
                },
            },
        }),
        subtitle: {
            fontWeight: '500',
            color: colors.color4,
            width: '150px',
            marginTop: 1,
            height: '36px'
        },
        subtitleText: {
            fontWeight: '500',
            color: colors.color4,
            width: '150px',
            height: '36px'
        },
        containerChildren: {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
        },
        containerChildrenText: {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            minHeight:'53px',
            alignItems: 'center'
        },
        containerChildrenSelect: {
            display: 'flex',
            gap: 3,
            width: '100%',
        },
        containerAdd: {
            display: 'flex',
            gap: 3,
            flex: 1,
        },
        containerAddText: {
            display: 'flex',
            gap: 3,
            flex: 1,
            alignItems: 'center',
        },
        children: {
            width: '400px'
        },
        childrenText: {
            //paddingLeft: '4px',
            '& .MuiFormControlLabel-root':{
                marginRight: 0,
                marginLeft: 0,
            },
            minWidth: '210px'
        },
        childrenSelect: {
            width:'300px'
        },
        inputContainer: { 
            width: '100%', 
            display: 'flex', 
            gap: 3, 
            flexWrap: 'wrap'
        },
        inputType: {
            width:'250px'
        },
        inputySubValue: {
            width:'300px'
        },
        inputText: {
            minWidth:'268px', 
            paddingRight:1 
        },
        inputImport: {
            paddingRight:1, 
            flex: 1, 
            alignItems: 'center', 
            display: 'flex', 
            justifyContent: 'end'
        },
        inputSubcatalog: {
            minWidth:'354px', 
            flex: 1, 
            paddingRight:1
        }
    }
}

export { useStyles }
